import inject from "scripts/ioc/inject";
import BaseView from "scripts/views/baseView";
import templateFooter from "templates/footer.hbs";
import { getFooterLogoOption } from "scripts/utils/whiteLabelUtil";

const chan = Backbone.Radio.channel;

class FooterView extends BaseView {
  get template() {
    return templateFooter;
  }

  constructor(
    options,
    selfEService = inject("selfEService"),
    securityService = inject("securityService"),
  ) {
    super(options);

    this.selfEService = selfEService;
    this.securityService = securityService;
  }

  get events() {
    return {
      "click #bb-footer-cookie-settings-link": "onClickCookieSettingsLink",
    };
  }

  render() {
    const user = this.securityService.getUser();
    const useDefaultSocialLink = user.getActiveOrganizationDynamicProperty(
      "useDefaultSocialLink",
    )
      ? user.getActiveOrganizationDynamicProperty("hideSocialLinks") === "1"
      : true;

    const externalUrls = JSON.parse(
      user.getActiveOrganizationDynamicProperty("externalUrls"),
    );

    const showSelfe = this.selfEService.getShowSelfE();
    const pressbooksUrl = user.getActiveOrganizationProperty("pressbooksUrl");
    const partnerSelfEUrl = this.selfEService.getPartnerSelfEUrl();
    const showAuthorsMenu = pressbooksUrl || partnerSelfEUrl || showSelfe;

    this.$el.html(
      this.template({
        showAuthorsMenu,
        showSelfe,
        pressbooksUrl,
        generalSelfEUrl: this.selfEService.getGeneralSelfEUrl(),
        partnerSelfEUrl,
        marketingUrl: user.getMarketingUrl(),
        marketingUrlName: user.getMarketingUrlName(),
        externalUrls,

        logo: getFooterLogoOption(
          user.getActiveOrganizationDynamicProperty("footerLogo"),
        ),
        pledgeUrl: user.getActiveOrganizationDynamicProperty("pledgeUrl"),
        platformTitle: user.getActiveOrganizationDynamicProperty(
          "platformTitle",
        ),
        orgSupportEmail: user.getActiveOrganizationDynamicProperty(
          "supportEmail",
        ),
        blogUrl: user.getActiveOrganizationDynamicProperty("blogUrl"),
        hideBiblioBlog: user.getActiveOrganizationDynamicProperty(
          "hideBiblioBlog",
        ),
        orgInfoEmail: user.getActiveOrganizationDynamicProperty("infoEmail"),
        externalAboutPageUrl: user.getActiveOrganizationDynamicProperty(
          "aboutPageUrl",
        ),
        twitterUrl:
          user.getActiveOrganizationDynamicProperty("twitterUrl") ||
          (useDefaultSocialLink ? "https://twitter.com/biblioboard" : null),
        facebookUrl:
          user.getActiveOrganizationDynamicProperty("facebookUrl") ||
          (useDefaultSocialLink
            ? "https://www.facebook.com/BiblioBoard"
            : null),
        instagramUrl:
          user.getActiveOrganizationDynamicProperty("instagramUrl") ||
          (useDefaultSocialLink ? "http://instagram.com/biblioboard" : null),
        linkedInUrl:
          user.getActiveOrganizationDynamicProperty("linkedInUrl") ||
          (useDefaultSocialLink
            ? "https://www.linkedin.com/company/1641574?trk=tyah&trkInfo=idx%3A1-1-1%2CtarId%3A1424272183652%2Ctas%3Abibliolabs"
            : null),
        showLegalNotices:
          user.getActiveOrganizationDynamicProperty("hideLegalNotices") !== "1",
        showAppLogos:
          process.env.PATRON_UI_SHOW_APP_LOGOS &&
          !user.getActiveOrganizationDynamicProperty("hideAppLogos"),
      }),
    );

    return this;
  }

  onClickCookieSettingsLink() {
    chan("display").request("showCookieSettingsModal");
    this.trigger("close");
  }
}

export default FooterView;
